import { Injectable } from '@angular/core';
import {BackendHttpService} from '../../core/backend-http.service';
import {apiEndpoints} from '../../app.constants';
import {Project} from '../../../models/project/project';
import {ErrorTemplate} from '../../../models/ErrorTemplate';
import {StringUtils} from '../../utils/string.utils';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class ProjectService extends BackendHttpService<any> {

  private createOrUpdateProjectSubject: BehaviorSubject<any> = new BehaviorSubject(null);

  /**
   * create a new project or update existing project
   * @param {Project} project
   * @returns {Observable<any>}
   */
  public createOrEditProject(project: Project) {
    let data = {
      advertiserID: project.advertiserId,
      keywords: project.keywords.map(keyword => ({
        id: keyword.id,
        keywordType: keyword.keywordType ? keyword.keywordType.id : 0,
        keyword: keyword.keyword
      })),
      name: project.name,
      countries: project.countries
    };

    if (project.id > 0) {
      data = Object.assign({}, data, {id: project.id});
      return this.post(apiEndpoints.updateProject, data);
    } else {
      return this.post(apiEndpoints.newproject, data);
    }
  }

  public deleteProject(projectId) {
    return this.delete(apiEndpoints.deleteProject.replace(':project_id', projectId));
  }

  public validateProject(project: Project): ErrorTemplate[] {
    const errors: ErrorTemplate[] = [];
    if (!project.name || StringUtils.trim(project.name) === '') {
      errors.push({name: 'project_name',
        message: this.translate.instant('project.name_mandatory')});
    }

    if (project.keywords.length === 0) {
      errors.push({name: 'project_keywords',
        message: this.translate.instant('project.keyword_mandatory')});
    }

    return errors;
  }

  public triggerCreateOrUpdateProject(project) {
    this.createOrUpdateProjectSubject.next(project);
  }

  get createOrUpdateProjectObserver() {
    return this.createOrUpdateProjectSubject.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/project/project.service.ts